// extracted by mini-css-extract-plugin
export var focusVisible = "wxvdpSvMqPY1YMPbmNz3";
export var icon = "x837LSq2gucCxLYKdVS6";
export var inline = "waXOBPqbwQtXbzOPECbX";
export var inlineText = "NqQu5XdX8K12B5Gv0aX4";
export var removePaddingLeft = "ZXxEmcSBKISc5WOAg3Zy";
export var removePaddingRight = "C7gwYa3SZ7W6776urHiA";
export var removeSidePadding = "LPtq66AKb973aUgtOux0";
export var root = "gGdal_ddEOs7ih_6PwNo";
export var text = "IsCcxeFVAWbXR3aID0Ub";